export default __webpack_public_path__ + "static/media/Perreo comabativo-hbf.90b46f36.jpg";